/**
 * Filtry listy zamowien: sklep (GET /api/locations/ + "nieznany adres"), status (kody z podsumowania),
 * zakres dat (szybkie wybory + od/do, domyslnie 90 dni), szukaj po numerze.
 *
 * Zaznaczony szybki zakres = PELNE tlo + kolor #fff ustawione INLINE - motyw wymusza !important
 * na przyciskach, a wyjatek :not([style*="background"]) w v3sys-theme.css dziala tylko dla inline
 * background. Nie zamieniac na klasy.
 */
import React from 'react';
import { SZYBKIE_ZAKRESY, dzisISO, NIEZNANY_ADRES, SKLEP_NIEZNANY_ID } from './format';

const WSZYSTKIE = '';
const pole = { padding: '4px 8px', fontSize: '11px', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)' };
const etykieta = { fontSize: '11px', color: 'var(--text-secondary)', whiteSpace: 'nowrap' };

export const ZakresDat = ({ zakres, onZmiana, zablokowane }) => {
  const dzis = dzisISO();
  const aktywny = SZYBKIE_ZAKRESY.find(z => z.od() === zakres.od && zakres.do === dzis)?.id || null;
  return (
    <div data-testid="zakres-dat" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
      <span style={{ color: 'var(--text-secondary)', fontWeight: 600 }}>Zakres</span>
      <div role="group" aria-label="Szybki zakres" style={{ display: 'flex', gap: '6px' }}>
        {SZYBKIE_ZAKRESY.map(z => {
          const jest = z.id === aktywny;
          return (
            <button key={z.id} type="button" data-testid={`zakres-${z.id}`} aria-pressed={jest} disabled={zablokowane}
              onClick={() => onZmiana({ od: z.od(), do: dzis })}
              style={{
                padding: '4px 10px', fontSize: '11px', fontWeight: 600, borderRadius: '12px', cursor: 'pointer',
                border: '1px solid var(--primary)',
                background: jest ? 'var(--primary)' : 'var(--card-bg)',
                color: jest ? '#fff' : 'var(--primary)',
              }}>
              {z.etykieta}
            </button>
          );
        })}
      </div>
      <label style={etykieta}>
        od{' '}
        <input type="date" aria-label="Data od" value={zakres.od || ''} max={zakres.do || dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, od: e.target.value })} style={pole} />
      </label>
      <label style={etykieta}>
        do{' '}
        <input type="date" aria-label="Data do" value={zakres.do || ''} min={zakres.od || undefined} max={dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, do: e.target.value })} style={pole} />
      </label>
    </div>
  );
};

/**
 * Props: sklepy [{id, nazwa}] (z /api/locations/), sklepId (null = wszystkie, 0 = nieznany adres),
 * statusy [{kod, etykieta, liczba}] (z podsumowania), status (null = wszystkie), szukaj, zakres.
 */
const Filtry = ({ sklepy, sklepId, onSklep, statusy, status, onStatus, szukaj, onSzukaj, zakres, onZakres, zablokowane }) => {
  const listaSklepow = Array.isArray(sklepy) ? sklepy : [];
  const listaStatusow = Array.isArray(statusy) ? statusy : [];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px' }}>
      <ZakresDat zakres={zakres} onZmiana={onZakres} zablokowane={zablokowane} />
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
        <label style={etykieta}>
          Sklep{' '}
          <select aria-label="Sklep" data-testid="filtr-sklep"
            value={sklepId === null || sklepId === undefined ? WSZYSTKIE : String(sklepId)}
            onChange={(e) => onSklep(e.target.value === WSZYSTKIE ? null : Number(e.target.value))}
            style={pole}>
            <option value={WSZYSTKIE}>wszystkie sklepy</option>
            {listaSklepow.map(s => <option key={s.id} value={String(s.id)}>{s.nazwa || s.name || `Sklep ${s.id}`}</option>)}
            <option value={String(SKLEP_NIEZNANY_ID)}>{NIEZNANY_ADRES}</option>
          </select>
        </label>
        <label style={etykieta}>
          Status{' '}
          <select aria-label="Status" data-testid="filtr-status"
            value={status === null || status === undefined ? WSZYSTKIE : String(status)}
            onChange={(e) => onStatus(e.target.value === WSZYSTKIE ? null : Number(e.target.value))}
            style={pole}>
            <option value={WSZYSTKIE}>wszystkie statusy</option>
            {listaStatusow.filter(s => s.kod !== null && s.kod !== undefined).map(s => (
              <option key={s.kod} value={String(s.kod)}>{s.etykieta} ({s.liczba ?? 0})</option>
            ))}
          </select>
        </label>
        <input type="search" value={szukaj} onChange={(e) => onSzukaj(e.target.value)} placeholder="Szukaj po numerze / uwagach…"
          aria-label="Szukaj po numerze" style={{ ...pole, marginLeft: 'auto', minWidth: '240px' }} />
      </div>
    </div>
  );
};

export default Filtry;
